import { render, staticRenderFns } from "./SettingsNotificationMailingBccNotifications.vue?vue&type=template&id=b6aa6064&"
import script from "./SettingsNotificationMailingBccNotifications.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailingBccNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports